<div class="div-arriere-plan-action" (click)="onDismiss(false)"></div>
<div class="div-global-action" style="text-align: center;" (click)="$event.stopPropagation()">
  <div id="center-square">
    <h1 class="text-lg dark-blue no-margin text-left">Confirmer la validation de la liste électorale ?</h1>

    <p class="grey text-left text-sm">
      Attention, la liste électorale va être verrouillée. Aucune modification ne sera plus possible.
    </p>
    
    <div class="flex gap-10 content-center">
      <v8te-active-button [buttonText]="'Non, je vérifie encore'" [primaryColor]="'#ffffff'" [secondaryColor]="'#FFECEC'"
        [textPrimaryColor]="'#2B2D67'" [textSecondaryColor]="'#EF4444'" [border]="'solid 1px #D9D9D9'"
        (click)="onDismiss(false)" [height]="'50'" [minWidth]="'120'" [width]="'240'"
        [bold]="'true'"></v8te-active-button>

      <v8te-active-button [buttonText]="'Je valide la liste électorale'" [primaryColor]="'#1990FF'" [secondaryColor]="'#1990FF'"
        [textPrimaryColor]="'#ffffff'" [textSecondaryColor]="'#32A24C'" [border]="'none'" (click)="onDismiss(true)"
        [height]="'50'" [minWidth]="'120'" [width]="'240'" [bold]="'true'"></v8te-active-button>

    </div>
  </div>
</div>